import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Growl } from 'primereact/growl';
import classnames from 'classnames';
import { RegisterUser } from './../../actions/userActions';
import { isNumeric } from './../../mainConf/functions';
import { syriaAreas } from './../../mainConf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { noInternetMessage } from './../../mainConf/index';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

class Register extends Component {
  constructor(props) {
    super(props);
    document.title = 'تسجيل حساب | Ikar.sy';
    this.state = {
      pageTitle: '',
      pageDescription: '',
      noMessages: true,
      user: {},
      name: '',
      areas: [],
      city: '',
      province: 'غير محدد',
      userType: 'غير محدد',
      area: 'غير محدد',
      contact_email: '',
      password: '',
      password_configuration: '',
      isAgencyAdmin: false,
      isIkarAdmin: false,
      surname: '',
      title: '',
      description: '',
      roles: [],
      mobile: '',
      facebook: '',
      whatsapp: '',
      agency_ref_id: '',
      agency_rank: 100,
      errors: {},
      resMessages: {},
      resType: '',
    };
    this.growl = React.createRef();
  }

 
  onUserTypeChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

  };

  onProvinceChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    if (e.target.value === 'دمشق') {
      //دمشق
      this.setState({ areas: syriaAreas.damascusAreas, phone: '0096311' });
    } else if (e.target.value === 'ريف دمشق') {
      //ريف دمشق
      this.setState({
        areas: syriaAreas.rifDamascusAreas,
        phone: '0096311',
      });
    } else if (e.target.value === 'حلب') {
      //حلب
      this.setState({
        areas: syriaAreas.aleppoAreas,
        phone: '0096321',
      });
    } else if (e.target.value === 'طرطوس') {
      //طرطوس
      this.setState({
        areas: syriaAreas.tartousAreas,
        phone: '0096343',
      });
    } else if (e.target.value === 'اللاذقية') {
      //اللاذقية
      this.setState({ areas: syriaAreas.latakiaAreas, phone: '0096341' });
    } else if (e.target.value === 'حمص') {
      //حمص
      this.setState({
        areas: syriaAreas.homsAreas,
        phone: '0096331',
      });
    } else if (e.target.value === 'حماة') {
      //حماة
      this.setState({ areas: syriaAreas.hamaAreas, phone: '0096333' });
    } else if (e.target.value === 'السويداء') {
      //السويداء
      this.setState({ areas: syriaAreas.asuwaydaAreas, phone: '0096316' });
    } else if (e.target.value === 'الحسكة') {
      //الحسكة
      this.setState({
        areas: syriaAreas.hasakaAreas,
        phone: '0096352',
      });
    } else if (e.target.value === 'درعا') {
      //درعا
      this.setState({ areas: syriaAreas.daraaAreas, phone: '0096315' });
    } else if (e.target.value === 'ادلب') {
      //ادلب
      this.setState({
        areas: syriaAreas.idlibAreas,
        phone: '0096323',
      });
    } else if (e.target.value === 'دير الزور') {
      //دير الزور
      this.setState({ areas: syriaAreas.deirezorAreas, phone: '0096351' });
    } else if (e.target.value === 'القنيطرة') {
      //القنيطرة
      this.setState({ areas: syriaAreas.quneitraAreas, phone: '0096314' });
    } else if (e.target.value === 'الرقة') {
      //الرقة
      this.setState({ areas: syriaAreas.raqqaAreas, phone: '0096322' });
    }else if (e.target.value === 'خارج سوريا - تركيا') {
      //تركيا
      this.setState({
        areas: syriaAreas.turkyeAreas, phone: '0090'
      });
    } else if (e.target.value === 'خارج سوريا - لبنان') {
      //لبنان
      this.setState({
        areas: syriaAreas.lebanonAreas, phone: '00961'
      });
    } else {
      this.setState({ areas: [], phone: '' });
    }
  };
  onSubmit = async (e) => {
    e.preventDefault();
    const {
      name,
      contact_email,
      password,
      password_configuration,
      isAgencyAdmin,
      isIkarAdmin,
      surname,
      title,
      province,
      description,
      area,
      userType,
      mobile,
      facebook,
      whatsapp,
      agency_ref_id,
      agency_rank,
    } = this.state;
    var area1 = area;
    if (area === 'غير محدد' || area === '')
      area1 = null;

    let errors = {};
    let resMessages = {};

    if (contact_email.trim() === '') {
      errors.contact_email = 'يجب ادخال الايميل';
    } else if (!/[\w+\-.]+@[a-zA-Z.-]+\.[a-z]{2,3}/.test(contact_email)) {
      errors.contact_email = 'يجب التأكد من الايميل المدخل';
    }
    if (password.trim() === '') {
      errors.password = 'يجب ادخال كلمة السر';
    } else if (password.length < 9) {
      errors.password = 'كلمة السر على الاقل تسعة رموز';
    }
    if (password_configuration.trim() === '') {
      errors.password_configuration = 'يجب ادخال اعادة كلمة السر';
    } else if (password !== password_configuration) {
      errors.password_configuration = 'كلمتا السر غير متطابقتين';
    }
    if (name.trim() === '') {
      errors.name = 'يجب ادخال الاسم';
    }
    if (province === 'غير محدد' || !province) {
      errors.province = 'يجب اختيار المحافظة';
    }
    if (
      (mobile !== null && mobile.trim() === '') ||
      mobile.trim() === '009639'||
      mobile.trim() === '0090' ||
      mobile.trim() === '00961'
    ) {
      errors.mobile = 'يجب ادخال رقم الموبايل';
    }else if (mobile.trim().length > 1 && !isNumeric(mobile.trim())) {
        errors.mobile = 'يجب التأكد من رقم الموبايل';
      }
    if (userType === 'غير محدد' || !userType) {
      errors.userType = 'يجب اختيار نوع الحساب';
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors, resMessages: {} });
      return;
    }
 
    const client = {
      name,
      contact_email,
      password,
      is_agency_admin: isAgencyAdmin,
      is_ikar_admin: isIkarAdmin,
      surname,
      title,
      province,
      city: area1 === '' ? null : area1,
      area: area1 === '' ? null : area1,
      description,
      roles: [],
      mobile,
      facebook,
      whatsapp,
      agency_ref_id,
      agency_rank,
    };
    const agency = {
      name,
      contact_email,
      password,
      is_agency_admin: isAgencyAdmin,
      is_ikar_admin: isIkarAdmin,
      surname,
      title,
      province,
      city: area1 === '' ? null : area1,
      area: area1 === '' ? null : area1,
      description,
      roles: [],
      mobile,
      facebook,
      whatsapp,
      agency_ref_id,
      agency_rank,
      blocked: false
    };
    const UserData = userType === 'صاحب مكتب' ? { agency, userType } : { client, userType };
  await this.props.RegisterUser(UserData);
  console.log(this.props);
    //  this.props.RegisterUser(UserData);
    
        // Show Growl on registration result
        if (this.props.requestFailed ) {
          // معالجة أخطاء السيرفر فقط إذا لم تكن الاستجابة 200
          let resMessages = {};
          resMessages.message='';
          if (
            this.props.requestFailedMessage &&
            this.props.requestFailedMessage.errorMessage &&
            this.props.requestFailedMessage.errorMessage.data &&
            this.props.requestFailedMessage.errorMessage.data.errors &&
            this.props.requestFailedMessage.errorMessage.data.errors[0]
          ) {
            const detail = this.props.requestFailedMessage.errorMessage.data.errors[0].detail;
            if(detail.includes('mobile : is in invalid format')||detail.includes('email must be unique')||detail.includes("mobile must be unique")||detail.includes('email : is in invalid format'))
          {  if (detail.includes('email must be unique')) {
              resMessages.message += 'الايميل المدخل موجود مسبقا';
            }  if (detail.includes("mobile must be unique")) {
              resMessages.message += 'رقم الموبايل المدخل موجود مسبقا';
            }  if (detail.includes('email : is in invalid format')) {
              resMessages.message += 'الرجاء التأكد من الايميل المدخل';
            }  if (detail.includes('mobile : is in invalid format')) {
              resMessages.message += 'الرجاء التأكد من رقم الموبايل المدخل';
            } }else {
              resMessages.message = 'حدثت مشكلة في إنشاء الحساب .. الرجاء المحاولة بعد قليل';
            }}
          // mobile : is in invalid format
          // } else {
          //   resMessages.message = 'حدثت مشكلة في إنشاء الحساب .. الرجاء المحاولة بعد قليل';
          // }
          this.setState({ resMessages });
          if (this.growl.current) {
            this.growl.current.show({
              severity: 'error',
              summary: 'فشل التسجيل',
              detail: resMessages.message,
              life: 5000
            });
          }
        }
        if ( !this.props.requestFailed ) {
          // Registration success
          this.setState({ resMessages: {} });
          if (this.growl.current) {
            this.growl.current.show({
              severity: 'success',
              summary: 'نجاح التسجيل',
              detail: 'تم إنشاء الحساب بنجاح ... الرجاء التحقق من بريدك الالكتروني لتفعيل الحساب',
              life: 3000
            });
          }
          // الانتقال لصفحة تسجيل الدخول بعد 3 ثواني
          setTimeout(() => {
            if (this.props.history) {
              this.props.history.push('/login');
            }
          }, 3000);
        }
      
    this.setState({ noMessages: false });
  //   this.setState({
  //     noMessages: true,
  //     name: '',
  //     contact_email: '',
  //     password: '',
  //     password_configuration: '',
  //     isAgencyAdmin: true,
  //     isIkarAdmin: false,
  //     surname: '',
  //     title: '',
  //     province: 'غير محدد',
  //     userType: 'غير محدد',
  //     city: '',
  //     area: 'غير محدد',
  //     description: '',
  //     roles: [],
  //     mobile: '',
  //     facebook: '',
  //     whatsapp: '',
  //     agency_ref_id: '',
  //     agency_rank: 100,
  //     errors: {},
  //     resMessages: {},
  //   });
  };
  // handleClear = (e) => {
  //   e.preventDefault();
  //   this.setState({
  //     noMessages: true,
  //     name: '',
  //     contact_email: '',
  //     password: '',
  //     areas: [],
  //     password_configuration: '',
  //     isAgencyAdmin: true,
  //     isIkarAdmin: false,

  //     surname: '',
  //     title: '',
  //     province: 'غير محدد',
  //     userType: 'غير محدد',
  //     description: '',
  //     roles: [],
  //     mobile: '',
  //     facebook: '',
  //     whatsapp: '',
  //     agency_ref_id: '',
  //     agency_rank: 100,
  //     errors: {},
  //   });
  // };
  onChange = (e) => this.setState({ [e.target.name]: e.target.value });
  render() {
    const {
      name,
      contact_email,
      password,
      password_configuration,
   surname,
   province
   ,area,
   areas,
   userType,
      title,
      description,
      mobile,
      facebook,
      whatsapp,
      agency_rank,
      errors,
    } = this.state;
    return (
      <div className="login-div">
        <Helmet>
          <title>{this.state.pageTitle}</title>
          <meta name="description" content={this.state.pageDescription} />
          <meta name="robots" content="noindex" />
        </Helmet>
        <div className="row">
          <div className="col-11 col-md-8 col-lg-7 col-xl-6 mx-auto">
            {/* {message ? (
                <Alert message={message} messageType={messageType} />
              ) : null} */}

            <div className="text-center pb-4 pt-3">
              <h1 className="main_title">
                <FontAwesomeIcon
                  icon={['fas', 'user-lock']}
                  size="1x"
                  className="second-color mx-2"
                />{' '}
                تسجيل حساب
              </h1>
              <Growl ref={this.growl} />
            </div>



              <React.Fragment>

              <form onSubmit={this.onSubmit} style={{ direction: 'rtl' }}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group text-right mb-4">
                    <label htmlFor="contact_email">البريد الالكتروني:</label>
                    <input
                      type="email"
                      className={classnames('form-control', {
                        'is-invalid': errors.contact_email,
                      })}
                      name="contact_email"
                      value={contact_email}
                      onChange={this.onChange}
                    />
                    {errors.contact_email && (
                      <div className="invalid-feedback">
                        {errors.contact_email}
                      </div>
                    )}
                  </div>
                  <div className="form-group text-right mb-4">
                    <label htmlFor="password">كلمة السر:</label>
                    <input
                      type="password"
                      className={classnames('form-control', {
                        'is-invalid': errors.password,
                      })}
                      name="password"
                      value={password}
                      onChange={this.onChange}
                    />
                    {errors.password && (
                      <div className="invalid-feedback">{errors.password}</div>
                    )}
                  </div>
                  <div className="form-group text-right mb-4">
                    <label htmlFor="password_configuration">
                      إعادة كلمة السر:
                    </label>
                    <input
                      type="password"
                      className={classnames('form-control', {
                        'is-invalid': errors.password_configuration,
                      })}
                      name="password_configuration"
                      value={password_configuration}
                      onChange={this.onChange}
                    />
                    {errors.password_configuration && (
                      <div className="invalid-feedback">
                        {errors.password_configuration}
                      </div>
                    )}
                  </div>

                  <div className="form-group text-right mb-4">
                    <label htmlFor="name">الاسم الكامل:</label>
                     <span className="display_mandatory">(مطلوب)</span>
                    <input
                      type="text"
                      className={classnames('form-control', {
                        'is-invalid': errors.name,
                      })}
                      name="name"
                      value={name}
                      onChange={this.onChange}
                    />
                    {errors.name && (
                      <div className="invalid-feedback">{errors.name}</div>
                    )}
                  </div>

                  <div className="form-group text-right mb-4">
                    <label htmlFor="title">العنوان:</label>
                    <input
                      type="text"
                      className={classnames('form-control', {
                        'is-invalid': errors.title,
                      })}
                      name="title"
                      value={title}
                      onChange={this.onChange}
                    />
                    {errors.title && (
                      <div className="invalid-feedback">{errors.title}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">

                   <div className="form-group text-right  mb-4">
                    <label htmlFor="province">
                      المحافظة:{' '}
                      <span className="display_mandatory">(مطلوب)</span>
                    </label>
                    <select
                      name="province"
                      className={classnames('form-control', {
                        'is-invalid': errors.province,
                      })}
                      onChange={this.onProvinceChange}
                      value={province}
                    >
                      <option value="غير محدد">غير محدد</option>
                      <option value="دمشق"> دمشق</option>
                      <option value="ريف دمشق"> ريف دمشق</option>
                      <option value="حلب"> حلب</option>
                      <option value="طرطوس"> طرطوس</option>
                      <option value="اللاذقية"> اللاذقية</option>
                      <option value="حمص"> حمص</option>
                      <option value="حماة"> حماة</option>
                      <option value="السويداء"> السويداء</option>
                      <option value="الحسكة"> الحسكة</option>
                      <option value="درعا"> درعا</option>
                      <option value="ادلب"> ادلب</option>
                      <option value="دير الزور"> دير الزور</option>
                      <option value="القنيطرة"> القنيطرة</option>
                      <option value="الرقة"> الرقة</option>
                      <option value="خارج سوريا - تركيا"> خارج سوريا - تركيا</option>
                      <option value="خارج سوريا - لبنان"> خارج سوريا - لبنان</option>
                    </select>
                    {errors.province && (
                      <div className="invalid-feedback">{errors.province}</div>
                    )}
                  </div>
                  <div className="form-group text-right  mb-4">
                    <label htmlFor="area">
                      المنطقة:{' '}
                      {/* <span className="display_mandatory">(مطلوب)</span> */}
                    </label>
                    <select
                      name="area"
                      className={classnames('form-control', {
                        'is-invalid': errors.area,
                      })}
                      onChange={this.onChange}
                      value={area}
                    >
                      <option value="غير محدد">غير محدد</option>
                      {areas.map((area, index) => (
                        <option value={area} key={index}>
                          {area}
                        </option>
                      ))}
                    </select>
                    {errors.area && (
                      <div className="invalid-feedback">{errors.area}</div>
                    )}
                  </div>
                  <div className="form-group text-right mb-4">
                    <label htmlFor="mobile">
                    {province==="خارج سوريا - تركيا" ? (
                                    <span> رقم الموبايل (________0090):{' '} </span>
                                  ) : province==="خارج سوريا - لبنان" ? (
                                    <span> رقم الموبايل (_________00961):{' '} </span>
                                  ) : <span> رقم الموبايل (_________009639):{' '} </span>}
								  
                      <span className="display_mandatory">(مطلوب)</span>
                      </label>
                    <input
                      type="number"
                      className={classnames('form-control', {
                        'is-invalid': errors.mobile,
                      })}
                      name="mobile"
                      value={mobile===''?province==="خارج سوريا - تركيا" ?'0090':province==="خارج سوريا - لبنان" ?'00961':'009639':mobile}
                      onChange={this.onChange}
                    />
                    {errors.mobile && (
                      <div className="invalid-feedback">{errors.mobile}</div>
                    )}
                  </div>
                  <div className="form-group text-right mb-4">
                    <label htmlFor="facebook">عنوان صفحة الفيسبوك:</label>
                    <input
                      type="text"
                      className={classnames('form-control', {
                        'is-invalid': errors.facebook,
                      })}
                      name="facebook"
                      value={facebook}
                      onChange={this.onChange}
                    />
                    {errors.facebook && (
                      <div className="invalid-feedback">{errors.facebook}</div>
                    )}
                  </div>
                  <div className="form-group text-right mb-4">
                    <label htmlFor="whatsapp">رقم الواتس اب:</label>
                    <input
                      type="number"
                      className={classnames('form-control', {
                        'is-invalid': errors.whatsapp,
                      })}
                      name="whatsapp"
                      value={whatsapp}
                      onChange={this.onChange}
                    />
                    {errors.whatsapp && (
                      <div className="invalid-feedback">{errors.whatsapp}</div>
                    )}
                  </div>


                  <div className="form-group text-right  mb-4">
                    <label htmlFor="province">
                      نوع  الحساب:{' '}
                      <span className="display_mandatory">(مطلوب)</span>
                    </label>
                    <select
                      name="userType"
                      className={classnames('form-control', {
                        'is-invalid': errors.userType,
                      })}
                      onChange={this.onUserTypeChange}
                      value={userType}
                    >
                      <option value="غير محدد">غير محدد</option>
                      <option value="صاحب مكتب"> صاحب مكتب</option>
                      <option value="مستخدم">  مستخدم</option>

                    </select>
                    {errors.userType && (
                      <div className="invalid-feedback">{errors.userType}</div>
                    )}
                  </div>





                 
                </div>
              </div>
              <div className="row">
                <div className="col-8 mx-auto">
                  <div className="row">
                    <div className="col-md-6">
                      <input
                        type="submit"
                        value="تسجيل"
                        className="btn btn-success btn-block submit-button m-1"
                      />
                    </div>

                  </div>
                </div>
              </div>
            </form>


                <div className="text-right py-2">

                  <Link to="/login">
                    <span className="display_7">   لدي حساب؟ تسجيل دخول </span>
                  </Link>
                </div>
              </React.Fragment>


          </div>
        </div>
      </div>
    );
  }
}

Register.propTypes = {
  RegisterUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  requestFailed: PropTypes.bool.isRequired,
  requestFailedMessage: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  user: state.user.user,
  requestFailed: state.user.requestFailed,
  requestFailedMessage: state.user.requestFailedMessage,
});


export default connect(mapStateToProps, { RegisterUser })(Register);
